






import { Component, Vue } from 'vue-property-decorator'
import TimelineView from '@/components/timeline/TimeLineCalendar.vue'
import { mapGetters } from 'vuex'

@Component({
  components: { TimelineView },
  computed: {},
})
export default class Timeline extends Vue {
  stickyHeaders = true
  dates = []
  data = []
  columns = []
}
